import { setSpotConfig } from '@host-panel/request/config';
import { TPlatform, TFieldsText } from '../../single-sign-on/types';
import { editSSOAccount } from './edit-account';
import { createSSOAccount } from './create-account';

export async function saveAccountData(
  platform: TPlatform,
  spot: any,
  data: TFieldsText,
  currentAccountType: string
) {
  const { value: type, mobile } = platform;
  const { id, name } = spot;
  await saveSSOAccountData(currentAccountType, data, type);
  await saveSSOTenantConfigs(id, type, mobile, name);
}

function saveSSOTenantConfigs(
  spotId: string,
  accountType: string,
  mobileOptions: string,
  spotName: string
): Promise<void> {
  return setSpotConfig(
    spotId,
    [
      {
        key: 'tenant.sso.account_type',
        value: accountType,
        expose: false,
        active: true
      },
      {
        key: 'tenant.sso.login_json',
        value: mobileOptions,
        expose: true,
        active: true
      }
    ],
    spotName
  );
}

function saveSSOAccountData(currentAccountType, data, type): Promise<void> {
  if (currentAccountType) {
    return editSSOAccount(currentAccountType, data);
  } else {
    return createSSOAccount(type, data);
  }
}
